import { CLPInvoiceItem } from "./clpTxn.model";
import { keyValue } from "./search.model";

export interface GenericResponse {
  statusCode: number,
  errorMsg: string
}

export interface SimpleResponse extends GenericResponse {
  messageString: string,
  messageString2: string,
  messageString3: string,
  messageString4: string,
  messageString5: string,
  messageInt: number,
  messageInt2: number,
  messageLong: number,
  messageBool: boolean,
  //contact-module
  list: keyValue[];
  dictionary: any[];
  dt: Date;
  messageArray: string[];
}


export interface CLPInvoiceItemListResponse extends SimpleResponse {
  listInvoiceItems: CLPInvoiceItem[];
  cLPInvoice: CLPInvoice;
}


export interface CLPInvoice {
  cLPInvoiceID: number;
  cLPCompanyID: number;
  invoiceNumber: string;
  totalAmount: number;
  status: number;
  isAnnualContract: boolean;
  dtModified: string;
  dtCreated: string;
}


export interface CreateCLPInvoiceResponse extends SimpleResponse {
  cLPInvoiceID: number;
  cLPTxnID: number;
}


export interface SimpleDataType {
  iD: number;
  msgBool1: boolean;
  msgBool2: boolean;
  msgBool3: boolean;
  messageString1: string;
  messageString2: string;
  messageString3: string;
  messageInt1: number;
  messageInt2: number;
  messageInt3: number;
}

export interface GenericObject {
  messageString: string,
  messageInt: number,
  messageBool: boolean
}
export interface DropDownItem {
  value: string;
  text: string;
}

export interface UserDD {
  value: number;
  text: string;
}

export interface GenericSmallList {
  id: number;
  text: number;
}

export interface IntDropDownItem {
  id: number;
  text: string;
}

export interface keyValueDropDown {
  value: number;
  text: string;
  isSelected: boolean;
}

export interface GridColoumn {
  field: string;
  title: string;
  width: string;
}


export interface IntDropDownItemListResponse extends SimpleResponse {
  intDropDownItemList: IntDropDownItem[];
}

